import moment from 'moment-timezone';
import { useState } from 'react';

import { DATE_TIME_FORMAT } from '../constants';

const DATE_CELLS = ['createdAt', 'scheduledDate', 'rescheduledDate'];

const descendingComparator = (a, b, orderBy) => {
  if (DATE_CELLS.includes(orderBy)) {
    const hasA = !!a[orderBy];
    const hasB = !!b[orderBy];

    if (!hasA && !hasB) return 0;
    if (!hasA) return -1;
    if (!hasB) return 1;

    const aDate = moment(a[orderBy], DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A);
    const bDate = moment(b[orderBy], DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A);

    if (bDate.isAfter(aDate)) return 1;
    if (bDate.isBefore(aDate)) return -1;
    return 0;
  }

  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
};

export const useTableSort = (defaultOrderBy, rows) => {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(defaultOrderBy);

  const onRequestSort = property => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedRows = rows.sort((a, b) =>
    order === 'desc'
      ? descendingComparator(a, b, orderBy)
      : -descendingComparator(a, b, orderBy),
  );

  return {
    order,
    orderBy,
    onRequestSort,
    sortedRows,
  };
};
